var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85489 0.146894C6.90146 0.19334 6.9384 0.248515 6.96361 0.30926C6.98881 0.370005 7.00179 0.435127 7.00179 0.500894C7.00179 0.566661 6.98881 0.631782 6.96361 0.692528C6.9384 0.753273 6.90146 0.808448 6.85489 0.854894L1.20789 6.50089L6.85489 12.1469C6.94878 12.2408 7.00152 12.3681 7.00152 12.5009C7.00152 12.6337 6.94878 12.761 6.85489 12.8549C6.76101 12.9488 6.63367 13.0015 6.50089 13.0015C6.36812 13.0015 6.24078 12.9488 6.14689 12.8549L0.146894 6.85489C0.10033 6.80845 0.0633873 6.75327 0.0381808 6.69253C0.0129744 6.63178 0 6.56666 0 6.50089C0 6.43513 0.0129744 6.37001 0.0381808 6.30926C0.0633873 6.24852 0.10033 6.19334 0.146894 6.14689L6.14689 0.146894C6.19334 0.100331 6.24852 0.0633878 6.30926 0.0381813C6.37001 0.0129749 6.43513 0 6.50089 0C6.56666 0 6.63178 0.0129749 6.69253 0.0381813C6.75327 0.0633878 6.80845 0.100331 6.85489 0.146894Z",
    fill: "#FFFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft1);
export default __webpack_public_path__ + "static/media/chevron-left (1).5087f129b25881b52bf23ba739dea2e4.svg";
export { ForwardRef as ReactComponent };